import 'ol/ol.css';
import { Vector as VectorLayer } from 'ol/layer'
import { Vector as VectorSource } from 'ol/source'
import { Style, Stroke, Fill } from 'ol/style.js';
import { Circle as CircleStyle, Text } from 'ol/style';
import { easeOut } from 'ol/easing.js';
import { getVectorContext } from 'ol/render.js';
import { hexToRgba } from 'utils/commonFunc';
import { setMapSingleEventHandler } from 'map/OlExtension'

export default class FacilityStatusLayer extends VectorLayer {
    styleGray = new Style({
        stroke: new Stroke({
            color: 'rgba( 200, 200, 200, 0.9)',
            width: 1
        }),
        fill: new Fill({
            color: 'rgba( 200, 200, 200, 0.7)'
        })
    });

    constructor(map, data) {
        super({
            name: 'facilityStatus',
            source: new VectorSource({features:data}),
            style: (feature) => this.styleFunction(feature),
        });
        this.map = map;
    }

    validAnimation = (duration) => {
        let start = Date.now();
        const map = this.map;
        const vector = this;
        this.on('postrender', function(event) {
            const elapsed = event.frameState.time - start;
            if (elapsed >= duration) {
                start = Date.now();
            } else {
                const vectorContext = getVectorContext(event);        
                const elapsedRatio = elapsed / duration;
                
                const radius = easeOut(elapsedRatio) * 5 + ((map.getView().getZoom() - 10) * 2);
                const opacity = easeOut(1 - elapsedRatio);
    
                const style = new Style({
                    image: new CircleStyle({
                        radius: radius,
                        stroke: new Stroke({
                            color: `rgba(255, 0, 0, ${(opacity*0.5)})`,
                            width: 1 + (opacity * 4),
                        }),
                    }),
                });
    
                vectorContext.setStyle(style);
                
                vector.validAnimationFeatureArr?.forEach((flashGeom) => {
                    vectorContext.drawGeometry(flashGeom);
                })
            }

            map.render();
        });
    }

    setOverlayContent = (isEnable, handler) => {
        setMapSingleEventHandler(this.map, this, 'click', isEnable ? (e, feature) => {
            handler(e, feature);
        } : undefined);
    }
    
    styleFunction = function (feature) {
        const properties = feature.get('properties')
        const valid = properties?.comm;
        const typeName = properties?.typeName;
        const defaultFill = properties?.fillColor;
        const zoom = Math.ceil(this.map.getView().getZoom());
        return new Style({
            image: new CircleStyle({
                radius: (zoom > 10 ? zoom - 10 : 2) * 2,
                fill: new Fill({
                    color: valid ? hexToRgba(defaultFill, 0.5) : defaultFill
                }),
                stroke: valid ? new Stroke({
                    color: 'rgba( 255, 255, 255, 1)',
                    width: 1
                }) : new Stroke({
                    color: 'rgba( 255, 0, 0, 0.7)',
                    width: 2
                })
            }),
            text: !valid || zoom > 14 ? new Text({
                text: typeName,
                font: `bold ${zoom}px Calibri,sans-serif`,
                textBaseline: 'top',
                fill: new Fill({
                    color: 'black',
                }),
                stroke: new Stroke({
                    color: 'white',
                    width: 2,
                }),
            }) : undefined,
            zIndex: valid ? -1 : 100
        });
    };

    update = (features) => {        
        const items = { };
        features.map((feature) => {
            const properties = feature.get('properties');
            items[`${properties.typeName}${properties.id}`] = properties;
            return items
        })
        
        this.getSource()?.forEachFeature(feature => {
            const properties = feature.get('properties');
            feature.set('properties', items[`${properties.typeName}${properties.id}`]);
        });

        this.createValidAnimationFeatures();
    }

    createValidAnimationFeatures = () => {
        const validAnimationFeatureArr = []
        this.getSource()?.forEachFeature(feature => {         
            const valid = feature.get('properties')?.comm;
            if (valid === false){                    
                const flashGeom = feature.getGeometry().clone();
                validAnimationFeatureArr.push(flashGeom);
            }
        });
        this.validAnimationFeatureArr = validAnimationFeatureArr;
    }
}